import { useEffect, useRef } from "react";
import { TYPO } from "styles/Typo";
import { confirmAdminDiscuss } from "utils/discuss";
import { OIcon, XIcon } from "../../Icons";
import { useVote } from "lib/analytics/react/hooks";

function ChoiceTemplete({
  detailDiscussData,
  submitVote,
  setWaitingHeight,
  type,
  isBoxShadow = true,
}: {
  detailDiscussData: any;
  submitVote: any;
  setWaitingHeight: any;
  type: "binary" | "multiple";
  isBoxShadow?: boolean;
}) {
  const options = detailDiscussData?.options;
  const isAdminDiscuss = confirmAdminDiscuss(detailDiscussData);
  const { start, success, fail } = useVote();
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (ref.current) {
      setWaitingHeight(ref.current.getBoundingClientRect().height);
    }
  }, [ref.current]);
  return (
    <div
      className={`py-6 flex flex-col w-full gap-2 bg-white rounded-[24px] ${
        isBoxShadow ? "border border-gray15" : ""
      }`}
      ref={ref}
      // style={{
      //   boxShadow: isBoxShadow ? "0px 0px 8px 0px rgba(0, 0, 0, 0.08)" : "none",
      //   WebkitBoxShadow: isBoxShadow
      //     ? "0px 0px 8px 0px rgba(0, 0, 0, 0.08)"
      //     : "none",
      // }}
    >
      <div className="px-6 flex flex-col gap-2">
        {options?.map((data: any, index: number) => (
          <div
            key={index}
            data-test-id={`vote-button-${data.symbol}`}
            className="flex items-center justify-between px-4 py-[13px] rounded-[12px] bg-gray2 cursor-pointer gap-2"
            onClick={() => {
              submitVote(data.value, data.symbol, success, fail);
              start({ report_id: detailDiscussData.id, option: data.symbol });
            }}
            data-gtm-id={`report-vote-button`}
          >
            <span
              className={`${TYPO.TYPO6_MD} break-all text-gray70`}
              data-testid={`vote-button-${data.symbol}-text`}
            >
              {data.value}
            </span>
            <div
              className={` bg-gray15 rounded-[6px] p-[3px] w-[18px] h-[18px] text-center flex items-center justify-center`}
            >
              {type === "binary" ? (
                data.symbol === "O" ? (
                  <OIcon size={13} />
                ) : (
                  <XIcon size={13} />
                )
              ) : (
                <span
                  className={`w-[13px] justify-center  text-[13px] font-semibold font-['Pretendard'] leading-[13px] text-gray40   text-center`}
                >
                  {(data.symbol as string).toUpperCase()}
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function VoteWaiting({
  detailDiscussData,
  submitVote,
  setWaitingHeight,
  isBoxShadow = true,
}: {
  detailDiscussData: any;
  submitVote: any;
  setWaitingHeight: any;
  mutate?: any;
  isBoxShadow?: boolean;
}) {
  let type = detailDiscussData?.agendaType;

  return (
    <ChoiceTemplete
      detailDiscussData={detailDiscussData}
      submitVote={submitVote}
      setWaitingHeight={setWaitingHeight}
      type={type}
      isBoxShadow={isBoxShadow}
    />
  );
}

export default VoteWaiting;
